export enum enumScheduleStatus {
  Active = 1,
  Inactive
}

export namespace enumScheduleStatus {
  export function values() {
    return Object.keys(enumScheduleStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
